module.exports = __webpack_public_path__ + "static/reliability-050e95a97faee84cd5623bbcc9372438.svg";